import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

/**
 * Route `title` values:
 * - `scope:key.path` → Transloco scoped key (e.g. `auth:login.title`)
 * - otherwise used as a literal (legacy English identifiers)
 */
@Injectable()
export class TranslocoTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (!title) {
      return;
    }

    const separator = title.indexOf(':');
    if (separator <= 0) {
      this.title.setTitle(title);
      return;
    }

    const scope = title.slice(0, separator);
    const key = title.slice(separator + 1);
    this.transloco
      .selectTranslate(key, {}, scope)
      .pipe(take(1))
      .subscribe((translated) => {
        this.title.setTitle(translated || key);
      });
  }
}
